import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@coolblue-development/next-image/client';
import BaseMediaGallery from './BaseMediaGallery.js';
export default function MediaGallery(props) {
    if (props.mediaGalleryItems.length === 0) {
        return _jsx(_Fragment, {});
    }
    return _jsx(BaseMediaGallery, { ...props, BaseImage: Image });
}
//# sourceMappingURL=MediaGallery.js.map